// src/api/api.jsx
import axios from 'axios';
import { createClient } from '@supabase/supabase-js';

// REACT_APP_API_URL is set per-branch in AWS Amplify (prod/staging).
// Fallback keeps local dev working without an .env file.
export const API_URL = process.env.REACT_APP_API_URL || (process.env.NODE_ENV === 'production'
  ? 'https://t73mjkykgp.us-east-1.awsapprunner.com'
  : 'http://localhost:8000');

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export const getDashboardSummary = (shopId, range) => 
  apiClient.get('/dashboard-summary', { params: { shop_id: shopId, range } });

export const generateShareLink = (shopId) =>
  apiClient.post('/generate-share-link', null, { params: { shop_id: shopId } });

export const getPublicDashboardSummary = (token, range) =>
  apiClient.get('/public/dashboard-summary', { params: { token, range } });

export const getPnLMetrics = (shopId, range) =>
  apiClient.get('/pnl-metrics', { params: { shop_id: shopId, range } });

// Create axios instance with credentials enabled
export const apiClient = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  credentials: 'include' // <-- This ensures cookies are sent with every request
});

// Axios request interceptor to attach the Authorization header synchronously from localStorage
apiClient.interceptors.request.use((config) => {
  // Get the JWT from localStorage (set after login)
  const jwt = localStorage.getItem('userId');
  // const jwt = localStorage.getItem('sb-jwt');
  if (jwt) {
    config.headers = config.headers || {};
    config.headers['Authorization'] = `Bearer ${jwt}`;
  }
  return config;
}, (error) => Promise.reject(error));